import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { DatePicker, Select, Button, Radio, message } from 'antd';
import 'antd/dist/reset.css';
import { dictsGetPaymentVids } from '../../../extensions/dicts';
import './rep-fin-report-header.css'
import RepFinFilter from "./rep-fin-filter"
import { ExportExcelButton, isMobile, PrintButton } from '../../../extensions/design';
import { useExcelData } from '../rep-excel-data-provider';
import { exportToExcel } from '../../../controls/export-to-excel/export-to-excel';

// Шапка финансового отчета с фильтрами по датам, по кассам, по типам сортировки
function RepFinReportHeader({ filters, onFilterChange, reportTypes, onRefresh }) {
  const [paymentVids, setPaymentVids] = useState([]);
  const [page, setPage] = useState("fin");
  const [showFilter, setShowFilter] = useState(false);
  const { excelDataTotal, excelData } = useExcelData();
  const navigate = useNavigate();

  useEffect(() => {
    if (excelDataTotal || excelData) {
      console.groupCollapsed("%c[RepFinReportHeader] Получены данные для Excel", "color: #4caf50; font-weight: bold;");
      console.log("excelDataTotal:", excelDataTotal);
      console.log("excelData:", excelData);
      console.groupEnd();
    }
  }, [excelDataTotal, excelData]);
  useEffect(() => { dictsGetPaymentVids(setPaymentVids) }, []);

  // Массив для мобильного селектора
  const pages = [
    { title: "Финансовый", link: "fin" },
    { title: "По продажам абонементов, пакетов", link: "abon"},
    { title: "По проданным товарам и оказанным услугам", link: "product"}
  ];

  const customTagRender = (props) => {
    return <span className="filters-tag-label">{props.label}</span>;
  };

  const handlePrint = () => {
    setTimeout(() => {
      window.print();
    }, 500);
  };

  const handleExport = () => {
    if (!excelDataTotal && !excelData) {
      message.warning("Нет данных для выгрузки");
      return;
    }
    const tables = [];
    // Добавляем основную таблицу
    if (excelDataTotal?.data?.length) {
      tables.push({
        title: excelDataTotal.title || "Общий отчет",
        colTitle: "Финансовый отчёт",
        columns: excelDataTotal.columns || [],
        data: excelDataTotal.data || []
      });
    }
    // Добавляем детальную таблицу, если есть
    if (excelData?.data?.length) {
      tables.push({
        title: excelData.title || "Детализация",
        colTitle: "Финансовый отчёт",
        columns: excelData.columns || [],
        data: excelData.data || [],
        summary: excelData.summary || []
      });
    }
    if (!tables.length) {
      message.warning("Нет данных для экспорта");
      return;
    }
    exportToExcel(tables, "Финансовый отчёт.xlsx");
  };
  return (
    isMobile ? 
      (
        <>
        <div className='selector-filer-section' style={{marginTop: 0}}>
            <Select value={page} onChange={(v) => { setPage(v); navigate(`/reports?tab=${v}`); }}>
              {pages.map(p => (
                <Select.Option key={p.link} value={p.link}>
                  {p.title}
                </Select.Option>
              ))}
            </Select>
            <img src="/images/filter.svg" alt="filter" onClick={() => {setShowFilter(!showFilter)}}/>
          </div>
          {showFilter && <RepFinFilter current={filters} reportTypes={reportTypes} onRefresh={onRefresh}
            onClose={(newFilters) => {
              if (newFilters) {
                onFilterChange(newFilters);
              }
              setShowFilter(false);
            }}
          />}
          
        </>
      ) :
      (
        <div className="filters-header-padding">
          <div className="filters-row">
            <span>Период с</span>
            <DatePicker
              value={filters.dateFrom}
              onChange={value => onFilterChange({dateFrom: value})}
              format="DD.MM.YYYY"
              allowClear={false}
            />
            <span>по</span>
            <DatePicker
              value={filters.dateTo}
              onChange={value => onFilterChange({dateTo: value})}
              format="DD.MM.YYYY"
              allowClear={false}
            />
            <span>Вид оплаты</span>
            <Select
              allowClear={false}
              mode="multiple"
              value={filters.cash}
              onSelect={value => onFilterChange({cash: [...filters.cash, value]})}
              onDeselect={value => onFilterChange({cash: [...filters.cash.filter(i => i !== value)]})}
              onClear={() => onFilterChange({cash: []})}
              options={paymentVids}
              className="filters-select"
              placeholder="По всем"
              maxTagCount={2}
              tagRender={customTagRender}
            />
            
            <Button onClick={onRefresh} size={isMobile ? "small" : "middle"}>Обновить</Button>
            <Radio.Group
              options={reportTypes}
              value={filters.reportType}
              optionType="button"
              buttonStyle="solid"
              size={ isMobile ? "small" : "middle" }
              onChange={e => onFilterChange({reportType: e.target.value})}
            />
            <div style={{display: "grid", gridTemplateColumns: "60px 60px", gap:"8px"}}>  
              <PrintButton onClick={handlePrint} />
              <ExportExcelButton onClick={handleExport} />
            </div>
          </div>
        </div>
      )
  );
}

export default RepFinReportHeader;
